export default __webpack_public_path__ + "9ba6a27387b96b7766d58159931b244c.png";